import routes from 'js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';

export async function createUserBulkFollowing(
  userIds: number[],
  source: string,
  auto?: boolean,
  detailMap: { [key: number]: { [key: string]: string | number } } = {},
) {
  const response = await fetchWithCsrf(
    routes.api_v0_bulk_following_index_path({
      subdomain_param: 'api',
    }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_ids: userIds,
        source,
        auto,
        source_detail_map: detailMap,
      }),
    },
  );
  if (!response.ok) {
    throw new Error('Failed to create user following');
  }
}

export async function deleteUserBulkFollowing(userIds: number[]) {
  const response = await fetchWithCsrf(
    routes.api_v0_bulk_following_index_path({
      subdomain_param: 'api',
    }),
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_ids: userIds,
      }),
    },
  );
  if (!response.ok) {
    throw new Error('Failed to delete user following');
  }
}

export async function followAndTagResearchInterest(
  research_interest: string,
  interest_following_source: string,
  user_topic_source: string,
) {
  const response = await fetchWithCsrf(
    routes.sutd_bulk_follow_research_interest_api_v0_user_taggings_user_taggings_path(
      {
        subdomain_param: 'api',
      },
    ),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        research_interest,
        interest_following_source,
        user_topic_source,
      }),
    },
  );
  if (!response.ok) {
    throw new Error('Failed to create RI user tagging');
  }
}

export async function fetchResearchInterestSubFields(
  research_interest: string,
): Promise<any> {
  return fetchWithCsrf(
    routes.get_follow_suggestions_api_v0_bulk_following_index_path({
      subdomain_param: 'api',
    }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        research_interest,
      }),
    },
  ).then((res) => {
    if (!res.ok) {
      throw new Error('Failed to fetch RI bulk follow lists');
    }
    return res.json();
  });
}
